import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
const calculateBalancedLayout = colorOptions => {
  const numOfOptions = colorOptions.length;
  const lines = Math.ceil(numOfOptions / 10);

  // Move the options from the last line (remaining options) to the previous lines
  const columnsPerLine = [];
  const base = Math.floor(numOfOptions / lines);
  let extras = numOfOptions % lines;
  let i = 0;
  while (i < lines) {
    columnsPerLine.push(base + (extras > 0 ? 1 : 0));
    extras -= 1;
    i += 1;
  }
  return {
    columnsPerLine,
    maxCols: Math.max(...columnsPerLine)
  };
};
const ColorSwatches = _ref => {
  let colorOptions = _ref.colorOptions,
    buttonProps = _ref.buttonProps;
  const _calculateBalancedLay = calculateBalancedLayout(colorOptions),
    columnsPerLine = _calculateBalancedLay.columnsPerLine,
    maxCols = _calculateBalancedLay.maxCols;
  const swatches = [];
  let colorIndex = 0;
  let lineIndex = 0;
  columnsPerLine.forEach(cols => {
    // Add colors of the line
    let i = 0;
    while (i < cols) {
      const color = colorOptions[colorIndex];
      colorIndex += 1;
      swatches.push(/*#__PURE__*/React.createElement(Button, _extends({
        key: "color-".concat(colorIndex)
      }, buttonProps(color))));
      i += 1;
    }

    // Add invisible spacers to complete the line
    let j = i;
    while (j < maxCols) {
      swatches.push(/*#__PURE__*/React.createElement("div", {
        key: "spacer-".concat(lineIndex, "-").concat(j),
        className: "color-swatch-spacer"
      }));
      j += 1;
    }
    lineIndex += 1;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "color-swatch-container",
    style: {
      gridTemplateColumns: "repeat(".concat(maxCols, ", 40px)")
    }
  }, swatches);
};
ColorSwatches.propTypes = {
  colorOptions: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})])).isRequired,
  buttonProps: PropTypes.func.isRequired
};
export default ColorSwatches;